export const setAppTitle = (portalName, pageTitle) => {
  document.title = portalName
    ? `${portalName}${pageTitle ? ` -  ${pageTitle}` : ''}`
    : pageTitle
}
